import React from 'react';
import { useSiteConfig } from '../contexts/SiteConfigContext';
import { Hero } from '../components/home/Hero';
import { Marquee } from '../components/site/Kit';
import { FeaturedProducts, MadeToOrder, AboutBlock, GalleryPreview, FinalCta } from '../components/home/Sections';

function HomePage() {
  const { config, loading } = useSiteConfig();

  if (loading || !config) {
    return <div className="min-h-screen flex items-center justify-center text-[#5f6672]">Cargando...</div>;
  }

  return (
    <div className="min-h-screen" data-testid="home-page">
      <Hero c={config} />
      <Marquee items={config.marquee_items} />
      <FeaturedProducts c={config} />
      <MadeToOrder c={config} />
      <AboutBlock c={config} />
      <GalleryPreview c={config} />
      <FinalCta title={config.final_cta_title} btn={config.final_cta_btn} />
    </div>
  );
}

export default HomePage;
